export const productSelector = (state) => state.product;
